import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import CreditFlowResearchRepository from '@/creditflowresearch/infrastructure/repository/CreditFlowResearchRepository';
import { IMarketCategory, IMarketCategoryPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketCategory';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';

const useCategoriesList = (categoriesList?: IMarketCategory[]) => {
  const container = getContainer();
  const requestService = container.get<CreditFlowResearchRepository>(CreditFlowResearchRepository);

  const [isFetching, setIsFetching] = useState(false);
  const [categories, setCategories] = useState<IMarketCategory[]>(categoriesList || []);

  const getCategories = async (payload: IMarketCategoryPayload) => {
    setIsFetching(true);
    try {
      const categories = await requestService.getMarketCategoriesList(payload);
      setCategories(categories);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  };

  return {
    categories,
    isFetching,
    getCategories,
  };
};

export default useCategoriesList;
